import webBiLogger from '@wix/web-bi-logger';
import { BI_EVENTS, biEventsMap, biConstants } from './biEvents';
import wix from '../services/wix';

let logger;

export const sendMessageEvent = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.SEND_MESSAGE, { mode });
};

export const expandChatEvent = direction => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.EXPAND_CHAT, { mode, direction });
};

export const messageReceivedEvent = shard_id => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.REALTIME_ACTIVITY, { mode, shard_id });
};

export const sendDebug = ({ tag, description }) => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.DEBUG, { tagId: tag, description, mode });
};

export const attachmentClickEvent = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.ADD_ATTACHMENT_CLICK, { mode });
};

export const imageClickEvent = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.IMAGE_CLICK, { mode });
};

export const chatDisplayedEvent = (deviceType, layoutName) => {
  const mode = wix.getViewMode();
  const loadTime = Date.now() - window.startLoadTime;
  const isFullRender = /fullRender/.test(window.location.href);
  return logger.log(BI_EVENTS.CHAT_DISPLAYED, {
    platform: deviceType === 'mobile' ? 'QAB' : 'desktop',
    load_time: loadTime,
    is_full_render: isFullRender,
    layoutName,
    mode,
  });
};

export const callToActionClickEvent = url => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.CALL_TO_ACTION_CLICK, { url, mode });
};

export const lcfSubmission = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.LCF_SUBMISSION, { mode });
};

export const copyCouponCode = () => {
  const mode = wix.getViewMode();
  return logger.log(BI_EVENTS.COPY_COUPON_CODE, { mode });
};

export const initLogger = ({
  instanceId: app_instance_id,
  biToken: bi_token,
  visitorId: visitor_id,
  viewMode: mode,
  isSocial: is_social,
  isBusiness: is_business,
}: any) => {
  logger = webBiLogger
    .factory({ endpoint: biConstants.BI_END_POINT })
    .setEvents(biEventsMap)
    .setDefaults({
      src: biConstants.BI_ENGAGE_SRC,
      app_instance_id,
      bi_token,
      visitor_id,
      is_social,
      is_business,
      mode,
    })
    .logger();
};
